import * as ConnectButton from './ConnectButton';
import * as ServerComms from './utilities/ServerComms';
import { useSignMessage, useAccount, useDisconnect } from 'wagmi';

function App(props) {

  var reallySignIn = props.reallySignIn;
  var randomCode = props.randomCode;
  var userID = props.userID;

  var message = 'Welcome to Cues! We are requesting your help to sign this message so that we can securely authenticate your account without knowing who you really are. This signing is free - it requires no gas fees or any other payment from you. Thank you.\n\nMessage ID: '+randomCode;

  function failFunction(e){
    console.log(e);
  }
  const { disconnect } = useDisconnect();

// data, isError, isLoading, isSuccess, 
  const { signMessage } = useSignMessage({
      message,
      onSuccess(data){
        var passObject = {
            u:'postSignIn',
            signKey:data,
            sessionID:document.sessionID,
            userID,
          };

        var postFunction = function(responseIn){
          console.log('w2');
          disconnect();
          reallySignIn(data, responseIn.v, {t:'wallet', v:address}, true);
        }

       ServerComms.fetchSomething(passObject, postFunction, failFunction, []);

      }
    })
// , connector, isConnected
  const {address} = useAccount({
    // address, connector,
    onConnect({  isReconnected }) {
          // console.log('Connected', { address, connector, isReconnected })
          if (!isReconnected){
            signMessage();
          }
        },    
  })
  
  return <ConnectButton.ConnectingButton />

//
}


export default App;
